
import Button from '@/components/NewUiElements/Buttons/Button'
import TextInput from '@/components/inputs/TextInput.vue'
import SectionLabel from '@/components/FileViewer/SectionLabel.vue'
import ChatIcon from '@/components/FileViewerModules/Chattable/ChatIcon.vue'

export default {
    name: 'UpdateOrCreateChatRoom',
    components: {
        TextInput,
        Button,
        SectionLabel,
        ChatIcon
    },
    props: {
        room: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data () {
        return {
            updateOrCreateForm: new this.$vForm({
                name: this.room ? this.room.name : ''
            })
        }
    },
    methods: {
        update () {
            this.$emit('update-chat-room', this.updateOrCreateForm.name)
            this.$emit('close')
        },
        create () {
            this.$emit('create-chat-room', this.updateOrCreateForm.name)
            this.$emit('close')
        }
    }
}
